import React, { useEffect } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../../redux/services/Imports';
import './StoriesBlock.scss';
import './StoriesBlock-media.scss';
import Story from '../StoryIcon/StoryIcon';
import { Props } from './interfaces';
import { ServiceData } from '../../../redux/services/ServiceRedux';

const StoriesBlock = ({ stories, storiesLoaded, alertLoaded }: Props) => {
  useEffect(() => {
    ServiceData.getAll({storiesLoaded, alertLoaded});
  }, []);

  return (
    <div
      className="stories-block"
      style={stories.length > 12 ? { justifyContent: 'flex-start', paddingBottom: '20px' } : {}}
    >
      {stories.map((item, i) => (
        <Story i={i} {...item} key={i} />
      ))}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(StoriesBlock));
